import React from 'react';

const ImageTextComponent = ({ image, title, description, reverse }) => {

  return (
    <div className="card mb-3 mt-3">
      <div className="row">
        <div className={`col-lg-12 col-xl-6 image-wrapper ${reverse ? 'order-md-2' : ''}`} style={{ padding: '0' }}>
          <div className="d-flex justify-content-center align-items-center">
            <img src={image} alt={title} className="img-fluid rounded shadow" style={{ width: '22rem' ,maxWidth: '100%', maxHeight: '100%' }} />
          </div>
        </div>
        <div className="col-lg-12 col-xl-6 text-dark">
          <div className="card-body text-center">
            <h5 className="card-title mt-2" style={{fontWeight: 'bold'}}>{title}</h5>
            <div className="card-text">
              {description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageTextComponent;